// import React, { useRef } from 'react';
// import { Maximize2, Wind, Lock } from 'lucide-react';

// export default function VerticalShades() {
//   const whatWeOfferRef = useRef(null); 
      
//         const scrollToSection = () => {
//           if (whatWeOfferRef.current) {
//             whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
//           }
//         };
//   const gallery = [
//     "images/vertical1.webp",
//     "images/vertical2.webp",
//     "images/vertical.jpg",
//   ];

//   return (
//     <div>
//       {/* Hero Section */}
//       <section className="relative h-screen bg-gradient-to-br from-indigo-900 to-purple-900">
//         <div className="absolute inset-0">
//           <div className="h-full w-full" style={{
//             backgroundImage: 'linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(0deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
//             backgroundSize: '100px 100px'
//           }}></div>
//         </div>
//         <div className="relative h-full max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center">
//           <div className="w-full md:w-1/2 text-white space-y-8">
//             <h1 className="text-6xl md:text-9xl font-bold leading-tight">Vertical<br />Shades</h1>
//             <p className="text-2xl text-gray-300">Perfect for large windows and sliding doors</p>
//             <button onClick={scrollToSection} className="px-8 py-3 bg-white text-indigo-900 rounded-full hover:bg-gray-100 transition-colors">
//               Discover More
//             </button>
//           </div>
//           <div className="w-full md:w-1/2 mt-12 md:mt-0">
//             <img
//               src={gallery[0]}
//               alt="Vertical shades showcase"
//               className="w-full h-[600px] object-cover rounded-3xl transform  shadow-2xl"
//             />
//           </div>
//         </div>
//       </section>

//       {/* Features */}
//       <section className="py-24 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
//             {[
//               {
//                 icon: <Maximize2 className="w-12 h-12" />,
//                 title: "Full Coverage",
//                 description: "Perfect for large windows and patio doors"
//               },
//               {
//                 icon: <Wind className="w-12 h-12" />,
//                 title: "Smooth Operation",
//                 description: "Effortless movement with premium tracking system"
//               },
//               {
//                 icon: <Lock className="w-12 h-12" />,
//                 title: "Secure Design",
//                 description: "Durable components for lasting performance"
//               }
//             ].map((feature, index) => (
//               <div key={index} className="relative group">
//                 <div className="absolute inset-0 bg-gradient-to-r from-indigo-100 to-purple-100 transform -skew-y-6 rounded-3xl transition-transform group-hover:skew-y-0"></div>
//                 <div className="relative p-8">
//                   <div className="text-indigo-600 mb-6">{feature.icon}</div>
//                   <h3 className="text-2xl font-bold mb-4">{feature.title}</h3>
//                   <p className="text-gray-600">{feature.description}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Gallery */}
//       <section ref={whatWeOfferRef} className="py-24 px-4 bg-gray-100">
//         <div className="max-w-6xl mx-auto">
//           <h2 className="text-4xl font-bold text-center mb-16">Style Gallery</h2>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {gallery.map((image, index) => (
//               <div key={index} className="group">
//                 <div className="relative overflow-hidden rounded-2xl">
//                   <img
//                     src={image}
//                     alt={`Vertical shade style ${index + 1}`}
//                     className="w-full h-[500px] object-cover transition-transform duration-700 group-hover:scale-110"
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-indigo-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
//                     <div className="absolute bottom-8 left-8">
//                       <h3 className="text-white text-2xl font-bold">Design {index + 1}</h3>
//                       <p className="text-white/80 mt-2">Contemporary vertical styling</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Applications */}
//       <section className="py-24 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
//             <div>
//               <h2 className="text-4xl font-bold mb-8">Perfect Applications</h2>
//               <div className="space-y-8">
//                 {[
//                   {
//                     title: "Sliding Glass Doors",
//                     description: "Ideal coverage for patio and sliding doors"
//                   },
//                   {
//                     title: "Large Windows",
//                     description: "Elegant solution for floor-to-ceiling windows"
//                   },
//                   {
//                     title: "Room Dividers",
//                     description: "Creative space separation with style"
//                   }
//                 ].map((app, index) => (
//                   <div key={index} className="flex items-start space-x-4">
//                     <div className="w-12 h-12 bg-indigo-100 rounded-xl flex items-center justify-center">
//                       <span className="text-indigo-600 font-bold">{index + 1}</span>
//                     </div>
//                     <div>
//                       <h3 className="text-xl font-bold mb-2">{app.title}</h3>
//                       <p className="text-gray-600">{app.description}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div>
//               <img
//                 src={gallery[2]}
//                 alt="Vertical shade applications"
//                 className="w-full rounded-2xl shadow-2xl"
//               />
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

import React, { useRef, useState } from "react";
import { Maximize2, Wind, Lock } from "lucide-react";

export default function VerticalShades() {
  const [activeIndex, setActiveIndex] = useState(null);
    
      const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
      };
      
  const whatWeOfferRef = useRef(null);

  const scrollToSection = () => {
    if (whatWeOfferRef.current) {
      whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const gallery = [
    "images/vertical1.webp",
    "images/vertical2.webp",
    "images/vertical.jpg",
    "images/verticaldesign.jpg",
    "images/verticaldesign1.jpg",
    "images/verticaldesign2.jpg",


  ];

  const features = [
    {
      title: "Light Control & Privacy",
      description:
        "Easily adjust the slats to control light and privacy, offering flexibility throughout the day.",
    },
    {
      title: "Sleek & Modern Design",
      description:
        "Ideal for large windows and sliding glass doors, providing a clean and contemporary look.",
    },
    {
      title: "Durable & Low Maintenance",
      description:
        "Made from high-quality materials like fabric, vinyl, or wood alternatives for long-lasting performance.",
    },
    {
      title: "UV Protection",
      description:
        "Reduces exposure to harmful UV rays, helping to protect your furniture and flooring from fading.",
    },
    {
      title: "Energy Efficiency",
      description:
        "Helps maintain indoor temperatures by reducing heat gain in summer and heat loss in winter.",
    },
    {
      title: "Custom Fit & Versatile Options",
      description:
        "Available in various colors, textures, and materials to complement any decor and window size.",
    },
  ];
  return (
    <div>
      {/* Hero Section */}
      <section className="relative h-screen bg-gradient-to-br from-[#393636] to-[#dac1c1]">
        <div className="absolute inset-0">
          <div
            className="h-full w-full"
            style={{
              backgroundImage:
                "linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(0deg, rgba(255,255,255,0.1) 1px, transparent 1px)",
              backgroundSize: "100px 100px",
            }}
          ></div>
        </div>
        <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center">
          <div className="w-full md:w-1/2 text-white space-y-6 pt-12">
            <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-9xl font-bold leading-tight text-center md:text-left">
              Vertical<br />Shades
            </h1>
            <h2 className="text-xl sm:text-2xl text-gray-300 text-center md:text-left">
              Perfect for large windows and sliding doors
            </h2>
            <div className="flex justify-center md:justify-start">
            <button
              onClick={scrollToSection}
              className="px-6 py-3 bg-white text-indigo-900 rounded-full hover:bg-gray-100 transition"
            >
              Discover More
            </button>
            </div>
            
          </div>
          <div className="w-full md:w-1/2 mt-12 md:mt-0">
            <img
              src={gallery[3]}
              alt="Vertical shades showcase"
              className="w-full h-[400px] md:h-[700px] object-cover rounded-3xl shadow-2xl"
            />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
            {[
              {
                icon: <Maximize2 className="w-12 h-12" />,
                title: "Full Coverage",
                description: "Perfect for large windows and patio doors",
              },
              {
                icon: <Wind className="w-12 h-12" />,
                title: "Smooth Operation",
                description: "Effortless movement with premium tracking system",
              },
              {
                icon: <Lock className="w-12 h-12" />,
                title: "Secure Design",
                description: "Durable components for lasting performance",
              },
            ].map((feature, index) => (
              <div key={index} className="relative group p-6 border rounded-xl bg-white shadow-lg">
                <div className="text-indigo-600 mb-4">{feature.icon}</div>
                <h3 className="text-xl font-bold">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section
        ref={whatWeOfferRef}
        className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-100"
      >
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">
            Style Gallery
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {gallery.map((image, index) => (
              <div key={index} className="group relative overflow-hidden rounded-2xl">
                <img
  src={image}
  alt={`Vertical shade style ${index + 1}`}
  className="w-full h-[300px] xl:h-[500px] object-cove transition-transform duration-700 group-hover:scale-105"
/>
{/* <img
                                        src={image}
                                        alt={`Roman shade design ${index + 1}`}
                                        className="w-full h-[300px] sm:h-[350px] md:h-[400px] lg:h-[450px] object-cover transition-transform duration-700 group-hover:scale-110"
                                    /> */}
                <div className="absolute inset-0 bg-gradient-to-t from-indigo-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4">
                    <h3 className="text-white text-lg font-bold">
                      Design {index + 1}
                    </h3>
                    <p className="text-white/80">Contemporary vertical styling</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Applications Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold mb-6">
                Perfect Applications
              </h2>
              <div className="space-y-6">
                {[
                  {
                    title: "Sliding Glass Doors",
                    description: "Ideal coverage for patio and sliding doors",
                  },
                  {
                    title: "Large Windows",
                    description: "Elegant solution for floor-to-ceiling windows",
                  },
                  {
                    title: "Room Dividers",
                    description: "Creative space separation with style",
                  },
                ].map((app, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center">
                      <span className="text-indigo-600 font-bold">{index + 1}</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold">{app.title}</h3>
                      <p className="text-gray-600">{app.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <img
                src={gallery[2]}
                alt="Vertical shade applications"
                className="w-full h-auto max-h-[400px] rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
<section className="mb-16 bg-white p-8 max-w-6xl mx-auto xl:pt-20 font-playfair">
  <h2 className="text-3xl md:text-6xl text-center font-semibold text-gray-800 mb-20">
    Key Features of Vertical Shades
  </h2>
  <div>
    {features.map((feature, index) => (
      <div key={index} className="border-b border-gray-400 p-3 mb-4">
        <div
          className="flex justify-between items-center cursor-pointer"
          onClick={() => toggleFAQ(index)}
        >
          <h3 className="text-xl md:text-4xl font-semibold text-gray-800 mb-6">
            {feature.title}
          </h3>
          <button
            className="text-xl md:text-4xl font-bold text-gray-600"
            aria-label="Toggle FAQ"
          >
            {activeIndex === index ? "-" : "+"}
          </button>
        </div>
        {activeIndex === index && (
          <p className="text-gray-600 mt-2 text-base md:text-2xl">
            {feature.description}
          </p>
        )}
      </div>
    ))}
  </div>
</section>;
    </div>
  );
}
